export default [
  {
    text: 'Business',
    value: 'business.name',
    apiSort: 'businesses.name',
  },
  {
    text: 'Country',
    value: 'country.name',
    apiSort: 'country',
  },
  {
    text: 'Network',
    value: 'name',
    apiSort: 'networks.name',
  },
  {
    text: 'Last status change',
    value: 'updated_at',
    apiSort: 'networks.updated_at',
  },
  {
    text: 'Edited by',
    value: 'updated_by',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'status.name',
    apiSort: 'status',
    width: '160px',
  },
];
